(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     CONFIG
     ═══════════════════════════════════════════ */
  var cfgEl = document.getElementById('unified-offer-data');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ═══════════════════════════════════════════
     STATE
     ═══════════════════════════════════════════ */
  var selectedOffer = null; // 'discount' | 'bogo1' | 'bogo2' | null
  var busy = false;

  /* ═══════════════════════════════════════════
     UTILITIES
     ═══════════════════════════════════════════ */

  function fmt(amount) {
    try {
      return new Intl.NumberFormat(Shopify.locale || 'en', {
        style: 'currency',
        currency: Shopify.currency.active
      }).format(amount);
    } catch (e) {
      return CFG.cur + amount.toFixed(2);
    }
  }

  function parseNum(txt) {
    if (!txt) return null;
    var s = txt.replace(/[^\d.,]/g, '').trim();
    if (!s) return null;
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
      if (s.lastIndexOf('.') < s.lastIndexOf(',')) s = s.replace(/\./g, '').replace(',', '.');
      else s = s.replace(/,/g, '');
    } else if (s.indexOf(',') > -1) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function getRate() {
    return parseFloat(Shopify.currency.rate) || 1;
  }

  function usdToLocal(usd) {
    return usd * getRate();
  }

  function localToUsd(local) {
    return local / getRate();
  }

  /* ═══════════════════════════════════════════
     PRICE DETECTION
     ═══════════════════════════════════════════ */

  function getSelectedVariantPrice() {
    // Method 1: checked radio -> label -> quantity-break price
    var checked = document.querySelector('input[type="radio"]:checked');
    if (checked && checked.id) {
      var label = document.querySelector('label[for="' + checked.id + '"]');
      if (label) {
        var priceEl = label.querySelector('.quantity-break__price span');
        if (priceEl) {
          var p = parseNum(priceEl.textContent);
          if (p) return { local: p, usd: localToUsd(p) };
        }
      }
    }

    // Method 2: nested radio inside label
    if (checked) {
      var parentLabel = checked.closest('label.quantity-break');
      if (parentLabel) {
        var pe = parentLabel.querySelector('.quantity-break__price span');
        if (pe) {
          var p2 = parseNum(pe.textContent);
          if (p2) return { local: p2, usd: localToUsd(p2) };
        }
      }
    }

    // Method 3: active quantity-break
    var activeQb = document.querySelector('.quantity-break--active .quantity-break__price span')
      || document.querySelector('.quantity-break.active .quantity-break__price span');
    if (activeQb) {
      var p3 = parseNum(activeQb.textContent);
      if (p3) return { local: p3, usd: localToUsd(p3) };
    }

    // Method 4: main price display
    var mainPrice = document.querySelector('.price-item--regular');
    if (mainPrice) {
      var p4 = parseNum(mainPrice.textContent);
      if (p4) return { local: p4, usd: localToUsd(p4) };
    }

    return null;
  }

  function detectTier(usdPrice) {
    if (CFG.tier2on && CFG.tier2.variantId && usdPrice >= CFG.tier2.threshold) return 2;
    if (CFG.tier1on && CFG.tier1.variantId && usdPrice >= CFG.tier1.threshold) return 1;
    return 0;
  }

  /* ═══════════════════════════════════════════
     XHR HELPERS (invisible to fetch intercept)
     ═══════════════════════════════════════════ */

  function xhrGet(url) {
    return new Promise(function (ok, fail) {
      var x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) {
          try { ok(JSON.parse(x.responseText)); } catch (e) { fail(e); }
        } else fail(new Error(x.status));
      };
      x.onerror = function () { fail(new Error('xhr')); };
      x.send();
    });
  }

  function xhrPost(url, data) {
    return new Promise(function (ok, fail) {
      var x = new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) {
          try { ok(JSON.parse(x.responseText)); } catch (e) { fail(e); }
        } else if (x.status === 422) {
          try {
            var resp = JSON.parse(x.responseText);
            fail(new Error(resp.description || 'This variant is currently unavailable. Please select another option.'));
          } catch (e) { fail(new Error('This variant is currently unavailable.')); }
        } else fail(new Error('network'));
      };
      x.onerror = function () { fail(new Error('network')); };
      x.send(JSON.stringify(data));
    });
  }

  /* ═══════════════════════════════════════════
     DRAWER REFRESH (surgical — preserves <cart-drawer> element)
     ═══════════════════════════════════════════ */

  function refreshDrawer() {
    var secs = 'cart-icon-bubble,cart-drawer';
    var u = window.location.pathname + '?sections=' + secs;

    return xhrGet(u).then(function (data) {
      // Update cart icon bubble
      if (data['cart-icon-bubble']) {
        var bubbleMount = document.getElementById('shopify-section-cart-icon-bubble');
        if (bubbleMount) {
          var bp = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          var bs = bp.getElementById('shopify-section-cart-icon-bubble');
          if (bs) bubbleMount.innerHTML = bs.innerHTML;
        }
      }

      // Update cart drawer WITHOUT destroying <cart-drawer> custom element
      if (data['cart-drawer']) {
        var dp = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

        var freshInner = dp.querySelector('.drawer__inner');
        var liveInner = document.querySelector('cart-drawer .drawer__inner');
        if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;

        var freshFooter = dp.querySelector('.drawer__footer');
        var liveFooter = document.querySelector('cart-drawer .drawer__footer');
        if (freshFooter && liveFooter) liveFooter.innerHTML = freshFooter.innerHTML;

        var drawer = document.querySelector('cart-drawer');
        var freshDrawer = dp.querySelector('cart-drawer');
        if (drawer && freshDrawer) {
          drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        }
      }

    }).catch(function (e) {
      console.warn('Drawer refresh error:', e);
    });
  }

  /* ═══════════════════════════════════════════
     NOTE: DN cart attribute detection (fetch intercept + drawer refresh)
     is handled by jci-mods.js — no duplicate interceptor here.
     ═══════════════════════════════════════════ */

  /* ═══════════════════════════════════════════
     PILL TAGS (variant label badges)
     ═══════════════════════════════════════════ */

  function updatePillTags() {
    if (!CFG.pills.on) return;

    var localT1 = usdToLocal(CFG.tier1.threshold);
    var localT2 = CFG.tier2on ? usdToLocal(CFG.tier2.threshold) : Infinity;

    // Method 1: quantity-break labels
    document.querySelectorAll('.quantity-break').forEach(function (lb) {
      var pe = lb.querySelector('.quantity-break__price span');
      if (!pe) return;
      var p = parseNum(pe.textContent);
      if (p == null) return;

      var tag = lb.querySelector('.offer__pill');
      if (CFG.tier2on && p >= localT2) {
        if (!tag) tag = createPill(lb);
        tag.textContent = CFG.pills.tier2;
      } else if (p >= localT1) {
        if (!tag) tag = createPill(lb);
        tag.textContent = CFG.pills.tier1;
      } else {
        if (tag) tag.remove();
      }
    });

    // Method 2: radio + label variant deal tags (classic style)
    document.querySelectorAll('.product-form__input input[type="radio"] + label').forEach(function (label) {
      var name = label.textContent.toLowerCase();
      if (!/(baselit|xenopixel|neopixel)/.test(name)) return;

      var span = label.querySelector('.quantity-break__price span');
      var raw = (span ? span.innerText : label.innerText).replace(/[^\d.,]/g, '').trim();
      if (raw.includes('.') && raw.includes(',')) {
        raw = raw.replace(/\./g, '').replace(/,/g, '.');
      } else if (/^[\d,]+$/.test(raw)) {
        raw = raw.replace(/,/g, '.');
      }
      var price = parseFloat(raw);
      if (isNaN(price)) return;

      var text = '';
      if (CFG.tier2on && price >= localT2) text = CFG.pills.tier2;
      else if (price >= localT1) text = CFG.pills.tier1;
      else return;

      if (!label.querySelector('.variant-deal-tag')) {
        var tag = document.createElement('div');
        tag.className = 'variant-deal-tag';
        tag.innerText = text;
        label.appendChild(tag);
      }
    });
  }

  function createPill(parent) {
    var d = document.createElement('div');
    d.className = 'offer__pill';
    var target = parent.querySelector('.quantity-break__left')
      || parent.querySelector('.quantity-break__content')
      || parent;
    target.appendChild(d);
    return d;
  }

  /* ═══════════════════════════════════════════
     OFFER SELECTION (mutually exclusive)
     ═══════════════════════════════════════════ */

  function selectOffer(type) {
    // Toggle behavior: clicking active offer deselects it
    if (selectedOffer === type) {
      selectedOffer = null;
    } else {
      selectedOffer = type;
    }
    clearError();
    updateOfferUI();
    updateBuyButtons();
  }

  function updateBuyButtons() {
    var atcBtn = document.querySelector('.atc-button');
    var offerBtn = document.getElementById('unified-offer-proceed');

    if (!offerBtn) return;

    if (selectedOffer) {
      if (atcBtn) atcBtn.style.display = 'none';
      offerBtn.style.display = 'block';
    } else {
      if (atcBtn) atcBtn.style.display = '';
      offerBtn.style.display = 'none';
    }
  }

  /* ═══════════════════════════════════════════
     ERROR DISPLAY
     ═══════════════════════════════════════════ */

  function showError(msg) {
    var el = document.getElementById('unified-offer-error');
    if (el) {
      el.textContent = msg;
      el.style.display = 'block';
    }
  }

  function clearError() {
    var el = document.getElementById('unified-offer-error');
    if (el) {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  /* ═══════════════════════════════════════════
     LOADER
     ═══════════════════════════════════════════ */

  function showLoader() {
    var loader = document.getElementById('unified-offer-proceed-loader');
    var text = document.getElementById('unified-offer-proceed-text');
    if (loader) loader.classList.remove('hidden');
    if (text) text.style.display = 'none';
  }

  function hideLoader() {
    var loader = document.getElementById('unified-offer-proceed-loader');
    var text = document.getElementById('unified-offer-proceed-text');
    if (loader) loader.classList.add('hidden');
    if (text) text.style.display = '';
  }

  /* ═══════════════════════════════════════════
     DN TOKEN — activate Discount Ninja promotion
     ═══════════════════════════════════════════ */

  function getDNToken() {
    if (selectedOffer === 'discount' && CFG.dnTokenDiscount) return CFG.dnTokenDiscount;
    if ((selectedOffer === 'bogo1' || selectedOffer === 'bogo2') && CFG.dnTokenBogo) return CFG.dnTokenBogo;
    return '';
  }

  function triggerDNPromotion(token) {
    if (!token) return;
    if (typeof discountNinja !== 'undefined' && discountNinja.api && discountNinja.api.promotions) {
      discountNinja.api.promotions.trigger(token);
    }
  }

  // Wait for DN to finish processing cart changes, then resolve.
  // Listens for la:dn:cart:updated with a fallback timeout.
  function waitForDN() {
    var token = getDNToken();
    if (!token) return Promise.resolve();

    return new Promise(function (resolve) {
      var done = false;

      function finish() {
        if (done) return;
        done = true;
        document.removeEventListener('la:dn:cart:updated', onDN);
        resolve();
      }

      function onDN() { finish(); }

      document.addEventListener('la:dn:cart:updated', onDN);

      // Fallback: if DN doesn't fire within 3s, proceed anyway
      setTimeout(finish, 3000);
    });
  }

  /* ═══════════════════════════════════════════
     CART READINESS — poll until DN changes are reflected
     ═══════════════════════════════════════════ */

  function pollCartUntilReady() {
    var isBogo = (selectedOffer === 'bogo1' || selectedOffer === 'bogo2');
    var maxAttempts = 12; // 400ms * 12 = 4.8s max
    var attempt = 0;

    return new Promise(function (resolve) {
      var interval = setInterval(function () {
        attempt++;
        xhrGet('/cart.js').then(function (cart) {
          var ready = false;

          if (isBogo) {
            // For BOGO: check freebie variant is in cart AND priced at 0 (discounted by DN)
            var freebieId = (selectedOffer === 'bogo2' && CFG.tier2on)
              ? CFG.tier2.variantId : CFG.tier1.variantId;
            ready = cart.items.some(function (item) {
              return item.variant_id === freebieId && item.final_line_price === 0;
            });
          } else {
            // For discount: DN writes its cart attribute when processing
            ready = cart.attributes &&
              cart.attributes.__limoniappsdiscountninja &&
              cart.attributes.__limoniappsdiscountninja !== '';
          }

          if (ready || attempt >= maxAttempts) {
            clearInterval(interval);
            resolve();
          }
        }).catch(function () {
          if (attempt >= maxAttempts) {
            clearInterval(interval);
            resolve();
          }
        });
      }, 400);
    });
  }

  /* ═══════════════════════════════════════════
     CART CLEANUP — remove freebies + wipe DN promotion state
     ═══════════════════════════════════════════ */

  function clearCartForNewOffer() {
    var freebieIds = [];
    if (CFG.tier1.variantId) freebieIds.push(CFG.tier1.variantId);
    if (CFG.tier2on && CFG.tier2.variantId) freebieIds.push(CFG.tier2.variantId);

    return xhrGet('/cart.js').then(function (cart) {
      var updates = {};
      var hasChanges = false;

      // Remove any freebie items from cart
      cart.items.forEach(function (item) {
        if (freebieIds.indexOf(item.variant_id) > -1) {
          updates[item.variant_id] = 0;
          hasChanges = true;
        }
      });

      // Wipe DN's server-side promotion state so the old promotion
      // doesn't persist and take priority over the new one.
      var hasDNAttr = cart.attributes &&
        cart.attributes.__limoniappsdiscountninja &&
        cart.attributes.__limoniappsdiscountninja !== '';

      if (hasChanges || hasDNAttr) {
        var payload = { updates: updates };
        if (hasDNAttr) {
          payload.attributes = { __limoniappsdiscountninja: '' };
        }
        return xhrPost('/cart/update.js', payload);
      }
    }).then(function () {
      // Also clear DN's browser-side cache so it doesn't re-apply the old promotion
      if (typeof discountNinja !== 'undefined' && discountNinja.api && discountNinja.api.cache) {
        discountNinja.api.cache.clear();
      }
    }).catch(function () { /* non-critical */ });
  }

  /* ═══════════════════════════════════════════
     PROCEED WITH OFFER (replaces Vercel draft order)
     ═══════════════════════════════════════════ */

  function proceedWithOffer() {
    if (!selectedOffer || busy) return;

    var btn = document.getElementById('unified-offer-proceed');

    // Double-click guard
    busy = true;
    if (btn) btn.disabled = true;
    showLoader();
    clearError();

    // Get selected variant from product form
    var variantId = null;

    var stickySelect = document.querySelector('.sticky-atc__variant-select option:checked');
    if (stickySelect) {
      variantId = stickySelect.getAttribute('data-variant-id');
    }

    if (!variantId) {
      var variantInput = document.querySelector('product-form input[name="id"]');
      if (variantInput) variantId = variantInput.value;
    }

    if (!variantId) {
      var checkedRadio = document.querySelector('.product-form__input input[type="radio"]:checked');
      if (checkedRadio) variantId = checkedRadio.value;
    }

    if (!variantId) {
      showError('Please select a variant.');
      hideLoader();
      if (btn) btn.disabled = false;
      busy = false;
      return;
    }

    var vid = parseInt(variantId);

    // Step 1: Clear freebies + wipe DN promotion state from previous offers
    clearCartForNewOffer().then(function () {

      // Step 2: Check if this variant is already in cart (avoid duplicates)
      return xhrGet('/cart.js');
    }).then(function (cart) {
      var alreadyInCart = cart.items.some(function (item) {
        return item.variant_id === vid;
      });

      // Step 3: Add main product to cart FIRST (skip if already there)
      if (alreadyInCart) return;
      return xhrPost('/cart/add.js', { items: [{ id: vid, quantity: 1 }] });
    }).then(function () {
      // Step 4: Trigger DN promotion AFTER item is in cart so DN can
      // evaluate cart contents and apply freebies / discounts properly
      triggerDNPromotion(getDNToken());

      // Step 5: Wait for DN to process (add freebie / apply discount)
      return waitForDN();
    }).then(function () {
      // Step 6: Poll cart to confirm DN has applied changes before redirecting.
      return pollCartUntilReady();
    }).then(function () {
      // Step 7: Redirect to checkout with DN token in URL for instant activation
      var token = getDNToken();
      if (token) {
        window.location.href = '/checkout?dn=' + encodeURIComponent(token);
      } else {
        window.location.href = '/checkout';
      }
    }).catch(function (err) {
      if (err.message === 'network') {
        showError('Something went wrong. Please check your connection and try again.');
      } else {
        showError(err.message);
      }
    }).finally(function () {
      hideLoader();
      if (btn) btn.disabled = false;
      busy = false;
    });
  }

  /* ═══════════════════════════════════════════
     SKIN A — Classic UI Controller
     ═══════════════════════════════════════════ */

  function updateClassicUI() {
    var d = document.getElementById('offer-discount');
    var b1 = document.getElementById('offer-bogo-1');
    var b2 = document.getElementById('offer-bogo-2');
    var lbl = document.getElementById('selected-offer-label');
    var priceEl = document.querySelector('.price-item--regular');

    var priceData = getSelectedVariantPrice();
    var usd = priceData ? priceData.usd : 0;
    var local = priceData ? priceData.local : null;
    var tier = detectTier(usd);

    // Show/hide BOGO buttons based on tier
    if (b1) b1.style.display = (tier === 1) ? 'inline-block' : 'none';
    if (b2) b2.style.display = (tier === 2) ? 'inline-block' : 'none';

    // Highlight active offer
    if (d) d.classList.toggle('active', selectedOffer === 'discount');
    if (b1) b1.classList.toggle('active', selectedOffer === 'bogo1');
    if (b2) b2.classList.toggle('active', selectedOffer === 'bogo2');

    // Update price display
    if (selectedOffer === 'discount' && local != null && priceEl) {
      if (lbl) lbl.innerText = CFG.discountPct + '% OFF';
      var discounted = local * (1 - CFG.discountPct / 100);
      priceEl.innerHTML =
        '<span style="text-decoration:line-through;opacity:.6;margin-right:8px">' + fmt(local) + '</span>' +
        '<span style="color:rgb(var(--accent-color))">' + fmt(discounted) + '</span>';
    } else if (selectedOffer === 'bogo1' && local != null && priceEl) {
      if (lbl) lbl.innerText = 'Buy 1 Get 1 FREE';
      priceEl.innerHTML =
        '<span>' + fmt(local) + '</span>' +
        '<span style="color:rgb(var(--accent-color));margin-left:8px;font-weight:bold">Buy 1 Get 1 FREE</span>';
    } else if (selectedOffer === 'bogo2' && local != null && priceEl) {
      if (lbl) lbl.innerText = 'Buy 1 Get 2 FREE';
      priceEl.innerHTML =
        '<span>' + fmt(local) + '</span>' +
        '<span style="color:rgb(var(--accent-color));margin-left:8px;font-weight:bold">Buy 1 Get 2 FREE</span>';
    } else {
      if (lbl) lbl.innerText = 'None';
      if (local != null && priceEl && !priceEl.querySelector('[style*="line-through"]')) {
        priceEl.textContent = fmt(local);
      }
    }
  }

  /* ═══════════════════════════════════════════
     SKIN B — Visual UI Controller
     ═══════════════════════════════════════════ */

  function updateVisualUI() {
    var track = document.getElementById('offer-track');
    var subtitle = document.getElementById('offer-subtitle');
    var mk1 = document.getElementById('offer-mk1');
    var mk2 = document.getElementById('offer-mk2');
    var lk1 = document.getElementById('offer-lk1');
    var lk2 = document.getElementById('offer-lk2');
    var cDiscount = document.getElementById('offer-card-discount');
    var cBogo1 = document.getElementById('offer-card-bogo1');
    var cBogo2 = document.getElementById('offer-card-bogo2');

    var priceData = getSelectedVariantPrice();
    var local = priceData ? priceData.local : 0;
    var usd = priceData ? priceData.usd : 0;
    var tier = detectTier(usd);

    var localT1 = usdToLocal(CFG.tier1.threshold);
    var localT2 = CFG.tier2on ? usdToLocal(CFG.tier2.threshold) : Infinity;

    var u1 = local >= localT1;
    var u2 = CFG.tier2on && local >= localT2;

    // Progress bar gradient
    if (track) {
      var g = 'rgba(255,255,255,.10)';
      var gr = 'rgba(34,197,94,.45)';
      var gn = '#22c55e';
      var max = CFG.tier2on ? CFG.tier2.threshold : CFG.tier1.threshold;
      var bg;

      if (u2) {
        bg = gn;
      } else if (u1 && CFG.tier2on) {
        var t1pct = (CFG.tier1.threshold / CFG.tier2.threshold * 100).toFixed(1);
        var curPct = Math.min(usd / CFG.tier2.threshold, 1) * 100;
        bg = 'linear-gradient(90deg, ' + gn + ' 0%, ' + gn + ' ' + t1pct + '%, ' + gr + ' ' + t1pct + '%, ' + gr + ' ' + curPct.toFixed(1) + '%, ' + g + ' ' + curPct.toFixed(1) + '%)';
      } else if (u1) {
        bg = gn;
      } else {
        var pct = (Math.min(usd / max, 1) * 100).toFixed(1);
        bg = 'linear-gradient(90deg, ' + gr + ' 0%, ' + gr + ' ' + pct + '%, ' + g + ' ' + pct + '%)';
      }
      track.style.setProperty('background', bg, 'important');
    }

    // Markers
    if (mk1) mk1.classList.toggle('on', u1);
    if (mk2) mk2.classList.toggle('on', u2);

    // Lock icons
    if (lk1) lk1.classList.toggle('off', u1);
    if (lk2) lk2.classList.toggle('off', u2);

    // Auto-deselect bogo1 if tier 2 is now available
    if (u2 && selectedOffer === 'bogo1') {
      selectedOffer = null;
      updateBuyButtons();
    }

    // Card states
    if (cDiscount) {
      cDiscount.classList.toggle('unlocked', true); // always available
      cDiscount.classList.toggle('active', selectedOffer === 'discount');
    }
    if (cBogo1) {
      // Hide tier 1 when tier 2 is available — no reason to show lesser offer
      if (u2) {
        cBogo1.style.display = 'none';
      } else {
        cBogo1.style.display = '';
        cBogo1.classList.toggle('unlocked', u1);
        cBogo1.classList.toggle('active', selectedOffer === 'bogo1');
        cBogo1.style.pointerEvents = u1 ? '' : 'none';
      }
    }
    if (cBogo2) {
      cBogo2.classList.toggle('unlocked', u2);
      cBogo2.classList.toggle('active', selectedOffer === 'bogo2');
      cBogo2.style.pointerEvents = u2 ? '' : 'none';
    }

    // Subtitle text
    if (subtitle) {
      if (selectedOffer === 'discount') {
        subtitle.textContent = CFG.discountPct + '% OFF selected';
      } else if (selectedOffer === 'bogo1') {
        subtitle.textContent = 'Buy 1 Get 1 FREE selected — free ' + CFG.tier1.name;
      } else if (selectedOffer === 'bogo2') {
        subtitle.textContent = 'Buy 1 Get 2 FREE selected — free ' + CFG.tier1.name + ' + ' + CFG.tier2.name;
      } else if (u2) {
        subtitle.textContent = 'You qualify for ' + CFG.tier1.name + ' + ' + CFG.tier2.name + ' FREE! Select an offer below.';
      } else if (u1) {
        subtitle.textContent = 'You qualify for a free ' + CFG.tier1.name + '! Select an offer below.';
      } else if (priceData && CFG.tier1on) {
        var diff = localT1 - local;
        subtitle.textContent = 'Spend ' + fmt(Math.max(0, diff)) + ' more to unlock a free ' + CFG.tier1.name + '!';
      } else if (priceData && CFG.discountEnabled) {
        subtitle.textContent = 'Select the ' + CFG.discountPct + '% OFF offer below!';
      } else {
        subtitle.textContent = 'Select a variant to see available offers';
      }
    }

    // Update main price display (same behavior as Classic skin)
    var priceEl = document.querySelector('.price-item--regular');
    if (priceEl && local) {
      if (selectedOffer === 'discount') {
        var discounted = local * (1 - CFG.discountPct / 100);
        priceEl.innerHTML =
          '<span style="text-decoration:line-through;opacity:.6;margin-right:8px">' + fmt(local) + '</span>' +
          '<span style="color:rgb(var(--accent-color))">' + fmt(discounted) + '</span>';
      } else if (selectedOffer === 'bogo1') {
        priceEl.innerHTML =
          '<span>' + fmt(local) + '</span>' +
          '<span style="color:rgb(var(--accent-color));margin-left:8px;font-weight:bold">Buy 1 Get 1 FREE</span>';
      } else if (selectedOffer === 'bogo2') {
        priceEl.innerHTML =
          '<span>' + fmt(local) + '</span>' +
          '<span style="color:rgb(var(--accent-color));margin-left:8px;font-weight:bold">Buy 1 Get 2 FREE</span>';
      } else if (!priceEl.querySelector('[style*="line-through"]')) {
        priceEl.textContent = fmt(local);
      }
    }
  }

  /* ═══════════════════════════════════════════
     UI ROUTER
     ═══════════════════════════════════════════ */

  function updateOfferUI() {
    if (CFG.skin === 'classic') updateClassicUI();
    else updateVisualUI();
  }

  /* ═══════════════════════════════════════════
     MAIN PRICE FIX (normalize on load)
     ═══════════════════════════════════════════ */

  function fixMainPrice() {
    var el = document.querySelector('.price-item--regular');
    if (!el) return;
    var n = parseNum(el.textContent);
    if (n != null) el.textContent = fmt(n);
  }

  /* ═══════════════════════════════════════════
     EVENT BINDING
     ═══════════════════════════════════════════ */

  function bindClick(id, fn) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', fn);
  }

  function init() {
    selectedOffer = null;

    // Skin A button handlers
    bindClick('offer-discount', function () { selectOffer('discount'); });
    bindClick('offer-bogo-1', function () { selectOffer('bogo1'); });
    bindClick('offer-bogo-2', function () { selectOffer('bogo2'); });

    // Skin B card handlers
    bindClick('offer-card-discount', function () { selectOffer('discount'); });
    bindClick('offer-card-bogo1', function () {
      // Only allow if tier qualifies
      var price = getSelectedVariantPrice();
      if (price && detectTier(price.usd) >= 1) selectOffer('bogo1');
    });
    bindClick('offer-card-bogo2', function () {
      var price = getSelectedVariantPrice();
      if (price && detectTier(price.usd) >= 2) selectOffer('bogo2');
    });

    // Proceed button
    bindClick('unified-offer-proceed', proceedWithOffer);

    // Variant change listener — keep offer selected if still applicable
    document.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"], select')) {
        clearError();

        // Theme JS updates price asynchronously. We run at 300ms, 600ms, and 1000ms
        // to catch different themes' update timings.
        var passes = [300, 600, 1000];
        passes.forEach(function (delay) {
          setTimeout(function () {
            var price = getSelectedVariantPrice();
            if (selectedOffer && price) {
              var tier = detectTier(price.usd);
              if (selectedOffer === 'bogo1' && tier < 1) selectedOffer = null;
              if (selectedOffer === 'bogo2' && tier < 2) selectedOffer = null;
              if (selectedOffer === 'bogo1' && tier >= 2) selectedOffer = 'bogo2';
            } else if (selectedOffer && !price) {
              if (selectedOffer !== 'discount') selectedOffer = null;
            }

            updatePillTags();
            if (!selectedOffer) fixMainPrice();
            updateOfferUI();
            updateBuyButtons();
          }, delay);
        });
      }
    });

    // MutationObserver: if theme JS overwrites the price element after our
    // updateOfferUI, re-apply offer styling immediately.
    var priceEl = document.querySelector('.price-item--regular');
    if (priceEl) {
      var updatingPrice = false;
      var priceObserver = new MutationObserver(function () {
        if (updatingPrice) return; // prevent infinite loop
        // If an offer is selected AND the price element no longer has our styled
        // HTML (theme JS overwrote it with plain text), re-apply.
        if (selectedOffer && priceEl.children.length === 0) {
          updatingPrice = true;
          updateOfferUI();
          updatingPrice = false;
        }
      });
      priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Initial render
    updatePillTags();
    updateOfferUI();
    updateBuyButtons();
    fixMainPrice();
  }

  /* ═══════════════════════════════════════════
     BOOTSTRAP
     ═══════════════════════════════════════════ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run pill tags after full page load (images/fonts may shift layout)
  window.addEventListener('load', function () {
    setTimeout(updatePillTags, 200);
  });

  // Shopify editor support
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 200);
  });

})();
